import React, { useState } from 'react';
import { motion } from 'framer-motion';
const items = [['Casa Loma', 'Residencial · 2024', 'Residencial', 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1200&q=85'], ['Apartamento R', 'Reforma integral · 2023', 'Reformas', 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=85'], ['Café Nido', 'Local comercial · 2024', 'Comercial', 'https://images.unsplash.com/photo-1559925393-8be0ec4767c8?auto=format&fit=crop&w=1200&q=85'], ['Casa Patio', 'Vivienda de autor · 2022', 'Residencial', 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=85'], ['Estudio M', 'Diseño de interiores · 2023', 'Interiores', 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1200&q=85'], ['Casa Umbral', 'Ampliación · 2024', 'Reformas', 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=85']];
export function Projects() {
  const [filter, setFilter] = useState('Todos');
  const tabs = ['Todos', 'Residencial', 'Comercial', 'Interiores', 'Reformas'];
  const shown = filter === 'Todos' ? items : items.filter(x => x[2] === filter);
  return <section id="proyectos" className="px-5 py-24 md:px-10 lg:py-32" data-id="element-166">
      <div className="mx-auto max-w-[1440px]" data-id="element-167">
        <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-168">
          Proyectos
        </p>
        <div className="mt-4 flex flex-col justify-between gap-7 md:flex-row md:items-end" data-id="element-169">
          <h2 className="font-editorial text-4xl md:text-5xl" data-id="element-170">
            Cada obra, una historia distinta
          </h2>
          <div className="flex flex-wrap gap-2" data-id="element-171">
            {tabs.map(t => <button key={t} onClick={() => setFilter(t)} className={`border px-3 py-2 text-[10px] font-bold uppercase tracking-wider ${filter === t ? 'border-[#1A1A1A] bg-[#1A1A1A] text-white' : 'border-[#d7d0c6] hover:border-[#1A1A1A]'}`} data-id="element-172">
                {t}
              </button>)}
          </div>
        </div>
        <motion.div layout className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-173">
          {shown.map(([name, meta,, image]) => <motion.article layout initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} key={name} className="group relative h-[380px] overflow-hidden bg-[#1A1A1A]" data-id="element-174">
              <img src={image} alt={name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-175" />
              <div className="absolute inset-0 flex flex-col justify-end bg-black/0 p-7 text-white transition-colors duration-300 group-hover:bg-black/45" data-id="element-176">
                <div className="translate-y-6 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100" data-id="element-177">
                  <h3 className="font-editorial text-3xl" data-id="element-178">{name}</h3>
                  <p className="mt-1 text-xs uppercase tracking-wider text-white/85" data-id="element-179">
                    {meta}
                  </p>
                </div>
              </div>
            </motion.article>)}
        </motion.div>
        <div className="mt-10 text-center" data-id="element-180">
          <a href="#contacto" className="border-b-2 border-[#C4724A] pb-2 text-xs font-bold uppercase tracking-wider" data-id="element-181">
            Ver portfolio completo →
          </a>
        </div>
      </div>
    </section>;
}